import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "..";
import { CountriesState, COUNTRIES_FEATURE_KEY } from "./countries.slice";

const getCountriesState = (rootState: StoreState): CountriesState => rootState[COUNTRIES_FEATURE_KEY];

const getCountries = createSelector(getCountriesState, (state: CountriesState) => state.countries);

const getCountriesLoading = createSelector(getCountriesState, (state: CountriesState) => state.loading);

const getCountriesError = createSelector(getCountriesState, (state: CountriesState) => state.error);

export const countriesSelectors = {
  getCountries,
  getCountriesLoading,
  getCountriesError,
};
